//公告api
import http from '../common/http'

export const getNoticeCenter = param=>(
  http.get('/Announcement/GetNoticeCenter',param)
)

export const getNoticeList=param=>(
    http.get('/Announcement/GetNoticeList',param)
)

export const getNoticeDetail=param=>(
  http.get('/Announcement/GetNoticeDetail',param)
)

export const getMessageList=param=>(
  http.get('/Announcement/GetMessageList',param)
)

export const getMessageDetail=param=>(
  http.get('/Announcement/GetMessageDetail',param)
)

export const sendSms=param=>(
  http.get('/Announcement/SendSms',param)
)

export const validateSms=param=>(
  http.get('/Announcement/ValidateSms',param)
)


export const testLoginout=param=>(
  http.post('/Account/LoginOut',param)
)


// WEBPACK FOOTER //
// ./src/api/announcementApi.js